import React, { useState, useEffect } from "react";
import s from "./change-log-block.module.scss";
import { getFormatDate, getFormatedDate } from "service/format-date";

const ChangeLogBlock = (props) => {

    const getDateFormat = (date) => {
        return getFormatDate(date, "DD-MM-YYYY");//moment(date).format("DD-MM-YYYY HH:mm:ss")
    }

    const getTimeFormat = (date) => {
        return getFormatDate(date, "HH:mm:ss");//moment(date).format("DD-MM-YYYY HH:mm:ss")
    }

    const [notificationType, setNotificationType] = useState(props.notificationType);
    const [content, setContent] = useState(props.content);
    const [incidentTime, setIncidentTime] = useState(getDateFormat(props.createdAt));
    const [releaseTag, setReleaseTag] = useState(props.releaseTag);

    useEffect(() => {
        //setItems(props.items);
        setNotificationType(props.notificationType);
        setContent(props.content);
        setIncidentTime(getDateFormat(props.createdAt));
        setReleaseTag(props.releaseTag);
    }, [props]);

    const createMarkup = (text) => {
        return {__html: text};
    }


    //const block = items.map(k => <div className={s.changelogBlock}>{k.content}</div>)
    const block = <div className={s.changelogBlock}>
        <div>
            <span className={s.notificationType}>{ props.getValue(notificationType) }</span>
            <div dangerouslySetInnerHTML={createMarkup(content)}></div>

        </div>
    </div>

    const versionBlock = <div className={s.versionBlock}>
        <span>{ incidentTime }</span>
        {/*<span>{props.getValue('VERSION')}: { releaseTag }</span>*/}
    </div>

    return (
        <div className={s.ChangeLogBlock}>
            { versionBlock }
            <div className={s.contentBlock}>
                { block }
            </div>
        </div>
    )
}

export default ChangeLogBlock;